export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10470.421c0ee9.jpg";